<template>
  <div class="modal offer-modal skin-modal offer-details-modal">
    <div class="overlay" @click="$emit('closeOfferDetailsModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeOfferDetailsModal')" src="./../assets/close.svg" />
      <div class="container">
        <form>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Details</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="title">Skin name</div>
                    <div class="desc">{{ $parent.orderToView.title }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Quality</div>
                    <div class="desc">{{ $parent.orderToView.quality }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Desired Price</div>
                    <div class="desc">
                      <b>{{ $parent.orderToView.user_price }} {{ $parent.orderToView.currency }}</b>
                    </div>
                  </div>
                  <div class="row row-spec">
                    <div class="title">Our price</div>
                    <div class="desc">
                      <b>{{ $parent.orderToView.service_price }} {{ $parent.orderToView.currency }}</b>
                    </div>
                  </div>

                  <div class="buttons">
                    <div class="button orange-btn" @click="decline()">
                      <span>Decline</span>
                    </div>
                    <div class="button red" @click="accept()">
                      <span>Accept</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferDetailsModal",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  methods: {
    closeOfferDetailsModal() {
      this.$emit("closeOfferDetailsModal");
    },
    decline() {
      let data = {
        id: this.$parent.orderToView.id,
      };
      this.$http
        .post(process.env.VUE_APP_API + "offer/decline", data)
        .then(() => {
          this.closeOfferDetailsModal();
          this.$parent.getOfferHistory();
        })
        .catch((res) => {
          console.error("Error declining offer:", res);
        });
    },
    accept() {
      this.$parent.openAcceptOfferModal();
    },
  },
  mounted() {
  },
};
</script>